import { apiClient } from '@/shared/lib/axios';
import { Town, TownQuery } from '@/types/admin-town';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type Response<T> = {
  data: {
    data: T[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
    };
    links: {
      prev: string | null;
      next: string | null;
    };
  };
};

export const getTownList = async (
  siteType: string | null,
  query?: TownQuery
): Promise<Response<Town>> => {
  const response = await apiClient.get<Response<Town>>(`/admin/${siteType}/towns`, {
    params: query,
  });
  return response.data;
};

export const useAdminTownList = (query: TownQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['towns', currentSite, query],
    queryFn: () => getTownList(currentSite, query),
    select: res => res.data,
  });
};
